const io = require('socket.io-client');
import store from '../state/store';
import app from '../main';
import { activateActivityTracker } from '../utils/helpers';

class Socket {
    constructor(params) {
        this.accessToken = params.accessToken;
        this.socket = null;
        this.connectionConfig = {
            transports: ['websocket'],
            upgrade: false
        };
        this.refreshWhiteList = [
            'deposits',
            'withdrawals'
        ];
        this.connectSocket();
    }

    async connectSocket() {
        const self = this;
        this.socket = io.connect(process.env.VUE_APP_SOCKET_URL, this.connectionConfig);
        this.socket.on('connect', async () => {
            self.socket.emit("auth", {
                accessToken: self.accessToken
            });

            self.socket.on('authenticated', async () => {
                activateActivityTracker();
                store.dispatch('auth/startTimer');
                self.socket.emit("transaction", {});
                self.socket.on('transaction', async (data) => {
                    await store.dispatch('notification/updateNotification', data);
                });

            });

        });
    }

    async _disconnectServer() {
        this.socket.disconnect();
    }

}

export default Socket;
